(() => {
  async function init(root) {
    if (root.dataset.ready || !root.dataset.customer) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const labels = JSON.parse($('[data-account-labels]').textContent);
    const t = key => labels[key] || labels.error;
    const el = (tag, text, className) => {
      const node = document.createElement(tag);
      if (text != null) node.textContent = text;
      if (className) node.className = className;
      return node;
    };
    const button = (text, action, secondary = false) => {
      const node = el('button', text, secondary ? 'lv-account-secondary' : 'button');
      node.type = 'button'; node.addEventListener('click', action); return node;
    };
    const card = () => el('div', null, 'lv-dashboard-card');
    const dialog = $('.lv-account-drawer');
    const drawer = $('[data-drawer-body]');
    const connectBox = $('[data-account-connection]');
    const connectButton = $('[data-connect]');
    const bodies = Object.fromEntries(['profile','orders','addresses'].map(key => [key,$(`[data-${key}-body]`)]));
    let api, Q, safeURL, profile, countries, current = 'overview', busy = false, originFocus, toastTimer, drawerVersion=0, formSequence=0;
    const cache = new Set();
    const inFlight = new Map();
    const currency = money => money ? new Intl.NumberFormat(root.dataset.locale, {style:'currency',currency:money.currencyCode}).format(Number(money.amount)) : '—';
    const date = value => new Intl.DateTimeFormat(root.dataset.locale,{dateStyle:'medium'}).format(new Date(value));
    const status = value => labels[(value || '').toLowerCase()] || t('unknown_status');
    function toast(message) {
      const node = $('.lv-account-toast'); node.textContent = message; node.hidden = false;
      clearTimeout(toastTimer); toastTimer = setTimeout(() => {node.hidden = true;},6000);
    }
    function skeleton(target) {
      target.replaceChildren(el('p',t('loading'),'lv-dashboard-hint'));
      target.setAttribute('aria-busy','true');
      for (let i=0;i<3;i++) {const bar=el('div',null,'lv-account-skeleton');bar.setAttribute('aria-hidden','true');target.append(bar);}
    }
    function fail(target, error, retry) {
      target.removeAttribute('aria-busy');
      const box=card(), message=el('p',t(['auth','identity'].includes(error.message)?'auth_error':'error'));
      message.setAttribute('role','alert'); box.append(message);
      if (['auth','identity'].includes(error.message)) {
        api?.clear(); profile=null; cache.clear();
        for (const body of Object.values(bodies)) if(body!==target) body.replaceChildren();
        connectBox.hidden=false; connectButton.hidden=false;
        $('[data-connection-message]').textContent=t('auth_error');
      } else if (retry) box.append(button(t('retry'),retry,true));
      target.replaceChildren(box);
    }
    function close() {if(!busy) dialog.close();}
    $('[data-close]').addEventListener('click',close);
    dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
    dialog.addEventListener('close',()=>{drawerVersion++;document.documentElement.classList.remove('lv-account-modal-open');originFocus?.focus();});
    function open(title) {
      if (dialog.open) return false;
      drawerVersion++;originFocus=document.activeElement;
      $('#lv-drawer-title').textContent=title;drawer.replaceChildren();
      dialog.showModal();document.documentElement.classList.add('lv-account-modal-open');return true;
    }
    function field(form,key,value='',type='text',required=false) {
      const wrap=el('div',null,'lv-account-field'),label=el('label',t(key));
      form.dataset.fieldPrefix ||= `lv-form-${++formSequence}`;
      const id=`${form.dataset.fieldPrefix}-${key}`;label.htmlFor=id;
      const input=el(type==='select'?'select':'input');input.id=id;input.name=key;
      if(type!=='select')input.type=type;
      input.value=value || '';input.required=required;input.maxLength=255;
      const error=el('p',null,'lv-account-field-error');error.id=id+'-error';error.hidden=true;
      input.setAttribute('aria-describedby',error.id);
      const validate=()=>{input.setCustomValidity(required&&!input.value.trim()?t('required'):'');};
      input.addEventListener('input',()=>{validate();input.removeAttribute('aria-invalid');error.hidden=true;});
      input.addEventListener('blur',()=>{validate();if(!input.checkValidity()){input.setAttribute('aria-invalid','true');error.textContent=t('required');error.hidden=false;}});
      input.addEventListener('invalid',()=>{input.setAttribute('aria-invalid','true');error.textContent=t('required');error.hidden=false;});
      wrap.append(label,input,error);form.append(wrap);return input;
    }
    async function save(form, action, after) {
      if(busy || !form.reportValidity()) return;
      busy=true;
      const controls=[...form.querySelectorAll('input,select,button')];
      controls.forEach(control=>{control.dataset.wasDisabled=String(control.disabled);control.disabled=true;});
      const error=form.querySelector('[data-form-error]');error.hidden=true;form.setAttribute('aria-busy','true');
      try {await action(); await after();toast(t('saved'));}
      catch(err) {
        if(['auth','identity'].includes(err.message)) {busy=false;dialog.close();fail(bodies[current]||connectBox,err);}
        else {error.textContent=t('error');error.hidden=false;error.focus();
          for(const entry of err.fields || []) {
            const mapping={firstName:'first_name',lastName:'last_name',phoneNumber:'phone',territoryCode:'country',zoneCode:'province'};
            const last=entry.field?.at(-1), input=form.elements.namedItem(mapping[last]||last);
            if(input) {input.setAttribute('aria-invalid','true');const msg=form.querySelector(`#${input.id}-error`);msg.textContent=t('error');msg.hidden=false;}
          }
        }
      } finally {busy=false;controls.forEach(control=>{control.disabled=control.dataset.wasDisabled==='true';});form.removeAttribute('aria-busy');}
    }
    function formEnd(form, submitText=t('save')) {
      const error=el('p',null,'lv-account-error');error.dataset.formError='';error.hidden=true;error.tabIndex=-1;error.setAttribute('role','alert');
      const actions=el('div',null,'lv-account-actions'),submit=el('button',submitText,'button');submit.type='submit';actions.append(submit);
      if(dialog.contains(form))actions.append(button(t('cancel'),close,true));
      form.append(error,actions);
    }
    function renderProfile() {
      const body=bodies.profile, form=el('form',null,'lv-dashboard-card lv-account-form');body.replaceChildren(form);
      field(form,'first_name',profile.firstName,'text',true).autocomplete='given-name';
      field(form,'last_name',profile.lastName,'text',true).autocomplete='family-name';
      const email=field(form,'email',profile.emailAddress?.emailAddress,'email');email.readOnly=true;
      form.append(el('p',t('email_readonly'),'lv-dashboard-hint'));formEnd(form);
      form.addEventListener('submit',event=>{
        event.preventDefault();const data=new FormData(form);
        save(form,()=>api.mutate('profileSave',{input:{firstName:data.get('first_name').trim(),lastName:data.get('last_name').trim()}}),async()=>{
          profile={...profile,firstName:data.get('first_name').trim(),lastName:data.get('last_name').trim()};
          $('[data-account-greeting]').textContent=t('hello').replace('__name__',profile.firstName);
        });
      });
      const prefs=card(),title=el('h3',t('preferences')),label=el('label',null,'lv-account-switch');
      const toggle=el('input');toggle.type='checkbox';toggle.checked=profile.emailAddress?.marketingState==='SUBSCRIBED';toggle.setAttribute('role','switch');
      label.append(toggle,el('span',t('marketing')));prefs.append(title,label);body.append(prefs);
      toggle.addEventListener('change',async()=>{
        const selected=toggle.checked;toggle.disabled=true;
        try {const payload=await api.mutate(selected?'subscribe':'unsubscribe');profile.emailAddress=payload.emailAddress;
          toggle.checked=payload.emailAddress.marketingState==='SUBSCRIBED';
          toast(t(payload.emailAddress.marketingState==='PENDING'?'marketing_pending':'saved'));
        } catch(err) {toggle.checked=!selected;if(['auth','identity'].includes(err.message))fail(body,err);else toast(t('error'));}
        finally{toggle.disabled=false;}
      });
    }
    async function addressForm(address, defaultID) {
      if(!open(t(address?'edit_address':'add_address')))return;
      const version=drawerVersion;
      skeleton(drawer);
      try {if(!countries){const response=await fetch(root.dataset.countriesUrl,{signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('api');countries=await response.json();}}catch(error){if(dialog.open&&version===drawerVersion)fail(drawer,error,()=>{dialog.close();addressForm(address,defaultID);});return;}
      if(!dialog.open||version!==drawerVersion)return;drawer.replaceChildren();drawer.removeAttribute('aria-busy');
      const form=el('form',null,'lv-account-form');drawer.append(form);
      const controls={};
      for(const [key,property,required] of [['first_name','firstName',true],['last_name','lastName',true],['address1','address1',true],['address2','address2',false],['city','city',true],['zip','zip',false]]) controls[property]=field(form,key,address?.[property],'text',required);
      const country=field(form,'country','','select',true);
      for(const item of countries)country.append(new Option(item.name,item.code));
      const province=field(form,'province','','select');
      country.value=address?.territoryCode||'TR';
      function provinces(value) {
        const entries=countries.find(item=>item.code===country.value)?.zones||[];
        province.replaceChildren();province.parentElement.hidden=entries.length===0;province.required=entries.length>0;
        province.append(new Option(t('choose'),''));
        for(const {code,name} of entries)province.append(new Option(name,code));
        province.value=value||'';
      }
      provinces(address?.zoneCode);country.addEventListener('change',()=>provinces());
      controls.phoneNumber=field(form,'phone',address?.phoneNumber,'tel');controls.phoneNumber.autocomplete='tel';
      const label=el('label',null,'lv-account-switch'),defaultInput=el('input');defaultInput.type='checkbox';defaultInput.checked=!!address&&address.id===defaultID;defaultInput.disabled=defaultInput.checked;
      label.append(defaultInput,el('span',t('default_address')));form.append(label);formEnd(form);
      form.addEventListener('submit',event=>{
        event.preventDefault();const input=Object.fromEntries(Object.entries(controls).map(([key,node])=>[key,node.value.trim()]));
        input.territoryCode=country.value;
        if(!input.territoryCode){toast(t('error'));return;}
        input.zoneCode=province.parentElement.hidden?null:province.value;
        const vars={address:input,defaultAddress:defaultInput.checked};if(address)vars.addressId=address.id;
        save(form,()=>api.mutate(address?'addressUpdate':'addressCreate',vars),async()=>{dialog.close();cache.delete('addresses');await load('addresses',true);});
      });
    }
    function deleteAddress(address) {
      if(!open(t('delete_address')))return;
      const form=el('form');drawer.append(form);form.append(el('p',t('delete_confirm')),el('p',(address.formatted||[]).join(', ')));formEnd(form,t('delete'));
      form.addEventListener('submit',event=>{event.preventDefault();save(form,()=>api.mutate('addressDelete',{addressId:address.id}),async()=>{dialog.close();cache.delete('addresses');await load('addresses',true);});});
    }
    async function addresses() {
      const body=bodies.addresses;
      let after, nodes=[],defaultID;
      do {const data=(await api.query(Q.addresses,{after})).customer;defaultID=data.defaultAddress?.id;nodes.push(...data.addresses.nodes);after=data.addresses.pageInfo.hasNextPage?data.addresses.pageInfo.endCursor:null;}while(after);
      body.replaceChildren(button(t('add_address'),()=>addressForm(null,defaultID)));
      const grid=el('div',null,'lv-dashboard-grid lv-address-grid');body.append(grid);
      if(!nodes.length){const empty=card();empty.classList.add('lv-account-empty');empty.append(el('h3',t('no_addresses')),el('p',t('no_addresses_text')));grid.append(empty);}
      for(const address of nodes) {
        const box=card();if(address.id===defaultID)box.append(el('span',t('default_address'),'lv-account-badge'));
        box.append(el('h3',[address.firstName,address.lastName].filter(Boolean).join(' ')));
        const lines=el('p');for(const line of address.formatted||[]){lines.append(document.createTextNode(line),el('br'));}box.append(lines);
        const actions=el('div',null,'lv-account-actions');actions.append(button(t('edit'),()=>addressForm(address,defaultID),true),button(t('delete'),()=>deleteAddress(address),true));
        if(address.id!==defaultID)actions.append(button(t('make_default'),async event=>{
          const target=event.currentTarget;target.disabled=true;
          try{await api.mutate('addressUpdate',{addressId:address.id,defaultAddress:true});cache.delete('addresses');await load('addresses',true);toast(t('saved'));}
          catch(error){if(['auth','identity'].includes(error.message))fail(body,error);else toast(t('error'));}
          finally{target.disabled=false;}
        },true));box.append(actions);grid.append(box);
      }
    }
    function image(data) {
      const src=safeURL(data?.url);if(!src)return null;
      const node=el('img');node.src=src;node.alt=data.altText||'';node.width=72;node.height=88;node.loading='lazy';return node;
    }
    function summaryLine(container,label,money) {const row=el('div');row.append(el('dt',t(label)),el('dd',currency(money)));container.append(row);}
    async function orderDetails(id) {
      if(!open(t('order_details')))return;
      const version=drawerVersion;
      async function fetchDetails() {
        skeleton(drawer);
        try {
          const order=(await api.query(Q.order,{id})).order;if(!order)throw new Error('api');
          let linePage=order.lineItems.pageInfo,fulfillmentPage=order.fulfillments.pageInfo;
          while(linePage.hasNextPage || fulfillmentPage.hasNextPage) {
            const more=(await api.query(Q.order,{id,after:linePage.endCursor,fulfillmentAfter:fulfillmentPage.endCursor})).order;
            if(linePage.hasNextPage){order.lineItems.nodes.push(...more.lineItems.nodes);linePage=more.lineItems.pageInfo;}
            if(fulfillmentPage.hasNextPage){order.fulfillments.nodes.push(...more.fulfillments.nodes);fulfillmentPage=more.fulfillments.pageInfo;}
          }
          if(!dialog.open||version!==drawerVersion)return;
          $('#lv-drawer-title').textContent=order.name;drawer.replaceChildren(el('p',date(order.processedAt)));
          const list=el('ul',null,'lv-account-items');
          for(const item of order.lineItems.nodes) {
            const row=el('li'),img=image(item.image),info=el('div');if(img)row.append(img);
            info.append(el('h3',item.title),el('p',`${t('quantity')}: ${item.quantity}`));row.append(info,el('span',currency(item.totalPrice)));list.append(row);
          }drawer.append(list);
          const totals=el('dl',null,'lv-dashboard-spec');
          for(const [label,key] of [['subtotal','subtotal'],['shipping','totalShipping'],['tax','totalTax'],['total','totalPrice'],['refunded','totalRefunded']]) if(order[key])summaryLine(totals,label,order[key]);
          drawer.append(totals,el('h3',t('shipping_address')),el('p',(order.shippingAddress?.formatted||[]).join(', ')||'—'),el('h3',t('tracking')));
          let tracked=false;
          for(const fulfillment of order.fulfillments.nodes)for(const info of fulfillment.trackingInformation||[]) {
            const url=safeURL(info.url);if(!url)continue;tracked=true;const link=el('a',[info.company,info.number].filter(Boolean).join(' · ')||t('tracking'),'lv-account-tracking');link.href=url;link.target='_blank';link.rel='noopener noreferrer';drawer.append(link);
          }
          if(!tracked)drawer.append(el('p',t('no_tracking')));
          drawer.append(el('p',t('order_help'),'lv-dashboard-hint'));
          const help=el('a',t('contact_support'),'lv-account-secondary');help.href='mailto:info@levartiaparfum.com?subject='+encodeURIComponent(order.name);drawer.append(help);
        } catch(error){if(dialog.open&&version===drawerVersion)fail(drawer,error,fetchDetails);}finally{if(version===drawerVersion)drawer.removeAttribute('aria-busy');}
      }
      await fetchDetails();
    }
    async function orders() {
      const body=bodies.orders;body.replaceChildren();const list=el('div');body.append(list);skeleton(list);
      const more=button(t('load_more'),()=>page(true),true);more.hidden=true;body.append(more);let cursor;
      async function page(append=false) {
        more.disabled=true;
        try {
          const result=(await api.query(Q.orders,{after:append?cursor:null})).customer.orders;
          if(!append){list.replaceChildren();list.removeAttribute('aria-busy');}
          if(!result.nodes.length&&!append){const empty=card();empty.classList.add('lv-account-empty');empty.append(el('h3',t('no_orders')),el('p',t('no_orders_text')));const discover=$('.lv-dashboard-discover .button').cloneNode(true);empty.append(discover);list.append(empty);}
          for(const order of result.nodes) {
            const box=el('article',null,'lv-dashboard-order'),info=el('div');info.append(el('h3',order.name),el('p',date(order.processedAt)));
            const badge=el('span',status(order.fulfillmentStatus),'lv-account-badge');badge.dataset.status=order.fulfillmentStatus;info.append(badge,el('p',status(order.financialStatus)));
            const pictures=el('div',null,'lv-account-order-images');for(const item of order.lineItems.nodes){const img=image(item.image);if(img)pictures.append(img);}
            box.append(info,el('strong',currency(order.totalPrice)),pictures,button(t('order_details'),()=>orderDetails(order.id),true));list.append(box);
          }
          cursor=result.pageInfo.endCursor;more.hidden=!result.pageInfo.hasNextPage;
        } catch(error){if(append){toast(t('error'));}else throw error;}finally{more.disabled=false;}
      }
      await page();
    }
    async function load(key,force=false) {
      if(!profile || key==='overview' || (!force&&cache.has(key)))return;
      if(inFlight.has(key))return inFlight.get(key);
      const promise=(async()=>{
        skeleton(bodies[key]);
        try{if(key==='profile')renderProfile();else if(key==='addresses')await addresses();else await orders();cache.add(key);}
        catch(error){fail(bodies[key],error,()=>load(key,true));}
        finally{bodies[key].removeAttribute('aria-busy');inFlight.delete(key);}
      })();inFlight.set(key,promise);await promise;inFlight.delete(key);
    }
    function show(focus=false) {
      const id=location.hash.slice(1);current=['overview','orders','addresses','profile'].includes(id)?id:'overview';
      root.querySelectorAll('.lv-dashboard-section').forEach(panel=>{panel.hidden=panel.id!==current;});
      root.querySelectorAll('[data-account-tab]').forEach(link=>{if(link.hash===`#${current}`)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
      if(focus)$(`#${current} h2`).focus({preventScroll:true});load(current);
    }
    root.querySelectorAll('[data-account-tab],[data-account-link]').forEach(link=>link.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();history.pushState(null,'',link.hash);show(true);
    }));
    window.addEventListener('hashchange',()=>show());window.addEventListener('popstate',()=>show());show();
    $('[data-account-logout]').addEventListener('click',()=>{api?.clear();for(const body of Object.values(bodies))body.replaceChildren();});
    try {
      const module=await import(root.dataset.apiUrl);
      Q=module.QUERIES;safeURL=module.safeURL;
      api=new module.AccountAPI({client:root.dataset.client,customer:root.dataset.customer,locale:root.dataset.locale});
      connectButton.addEventListener('click',async()=>{connectButton.disabled=true;try{await api.authorize();}catch(error){$('[data-connection-message]').textContent=t('error');connectButton.disabled=false;}});
      profile=await api.connect();
      if(profile){connectBox.hidden=true;await load(current);}
      else {$('[data-connection-message]').textContent=t('connect_info');connectButton.hidden=false;}
    }catch(error){$('[data-connection-message]').textContent=t(['auth','identity'].includes(error.message)?'auth_error':'error');connectButton.hidden=!api;}
  }
  document.querySelectorAll('[data-lv-dashboard]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lv-dashboard]').forEach(init));
})();
